import { signal } from "@lit-labs/signals";

export const colorSchemes = ["system", "light", "dark"] as const;
export type ColorScheme = (typeof colorSchemes)[number];

export const labels: Record<ColorScheme | "aria", string> = {
    system: "Auto",
    light: "Hell",
    dark: "Dunkel",
    aria: "Farbschema",
};

export function loadClientColorScheme(): ColorScheme {
    return (localStorage.getItem("color-scheme") as ColorScheme) || "system";
}

export const appColorScheme = signal(loadClientColorScheme());
